const Utils = {
  arrayToDictionary(array, key) {
    return Object.assign({}, ...array.map((x) => ({[x[key]]: x})));
  },
  arrayToDictionaryArray(array, key) {
    let dict = {}
    array.map((x) => {
      let dictKey = x[key];
      if(Array.isArray(dict[dictKey])) {
        dict[dictKey].push(x);
      } else {
        dict[dictKey] = [x];
      }
    });
    return dict;
  }
}
export default Utils